// extracted by mini-css-extract-plugin
export var errorIcon = "_ng-1";
export var nameLogo = "_ng-0";